import * as ko from "knockout";
import Bao from "./../services/bao-service";
// bao migrate - module not found: import Finito from "modules/finito-module";
import TabPage from "./../factories/tab-page";
import TabController from "./../factories/tab-controller";
import BaoMenu from "./../services/bao-menu";
import baoRouter from "./../services/bao-router";
import BaoDialog from "./../factories/bao-dialog";
import finitoService from "./../services/finito-service";
import Guid from "./../factories/guid";
import SubscriptionViewModel from "./../factories/subscription-view-model";
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-tabs";
import "./../bindings/filtering";
function WhiteboardReportViewModel(tabPage) {
    var self = this;
    SubscriptionViewModel.call(this, tabPage);
    self.ShowDeletedWhiteboardEntries = ko.observable(false);
    self.PageSize = ko.observable(10);
    self.PageIndex = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Selection = ko.observableArray();
    self.CustomFilter = ko.observable({});
    self.link = function (index, whiteboardModel) {
        var linkHash = "whiteboard/" + whiteboardModel.InstructionId() + "/" + self.TabPage.ObjectId();
        baoRouter.setHash(linkHash);
    };
    self.init = function () {
        self.TabPage.IsLoading(true);
        return $.when(self.getReport(), self.getWhiteboardEntries());
    };
    self.loaded = function () {
        var def = $.Deferred();
        self.TabPage.IsLoading(false);
        self.registerMenuClick();
        Bao.bindEvent("whiteboardEntries:refresh", function (value) {
            if (value.ReportId == self.ReportId()) {
                self.refresh();
            }
        });
        self.subscribe(self.Selection, function () {
            self.toggleButtons();
        });
        self.subscribe(self.Sorting, function () {
            self.getWhiteboardEntries();
        });
        self.subscribe(self.CustomFilter, function () {
            self.getWhiteboardEntries();
        });
        self.subscribe(self.ShowDeletedWhiteboardEntries, function () {
            self.getWhiteboardEntries();
        });
        self.subscribe(self.PageIndex, function () {
            self.getWhiteboardEntries();
        });
        def.resolve();
        return def.promise();
    };
    self.ToHashObject = function (customFilter) {
        var returnValue = [];
        for (var f in customFilter) {
            returnValue.push({
                Key: f,
                Value: ko.unwrap(customFilter[f])
            });
        }
        return returnValue;
    };
}
;
Bao.inherit(WhiteboardReportViewModel, SubscriptionViewModel);
WhiteboardReportViewModel.prototype.registerMenuClick = function () {
    var self = this;
    BaoMenu.registerEvent(function (btn) {
        if (self.TabPage != null && self.TabPage.IsActiveTab != null && self.TabPage.IsActiveTab() === true) {
            var methodString = btn.ActionKey().substr(self.FormName().length);
            if (methodString) {
                methodString = methodString.toLowerCase();
                if ($.isFunction(self[methodString])) {
                    self[methodString]();
                }
            }
        }
    });
};
WhiteboardReportViewModel.prototype.getReport = function () {
    var self = this;
    return Bao.post("WhiteboardReport/GetReport", JSON.stringify({
        id: self.TabPage.ObjectId()
    })).then(function (result) {
        ko.map.fromJS(result.Model, self);
        self.TabPage.Title(self.ReportShortTitle());
        self.TabPage.ToolTip(self.ReportTitle());
        self.toggleButtons();
    });
};
WhiteboardReportViewModel.prototype.getWhiteboardEntries = function () {
    var self = this;
    self.TabPage.IsLoading(true);
    var customFilter = self.ToHashObject(ko.unwrap(self.CustomFilter));
    return Bao.post("WhiteboardReport/GetAll", JSON.stringify({
        id: self.TabPage.ObjectId(),
        pageIndex: self.PageIndex(),
        pageSize: self.PageSize(),
        sorting: self.Sorting(),
        searchFilter: {
            ShowDeleted: self.ShowDeletedWhiteboardEntries()
        },
        customfilter: customFilter
    })).then(function (result) {
        ko.map.fromJS(result, self);
        self.toggleButtons();
        self.TabPage.IsLoading(false);
    });
};
WhiteboardReportViewModel.prototype.toggleButtons = function () {
    var self = this;
    if (self.FormName) {
        if (self.TotalRows && self.TotalRows() < 1) {
            BaoMenu.permissionEnable({
                ActionKey: self.FormName() + "Edit",
                Enabled: false,
                Context: self.TabPage.Context()
            });
            BaoMenu.permissionEnable({
                ActionKey: self.FormName() + "Delete",
                Enabled: false,
                Context: self.TabPage.Context()
            });
            BaoMenu.permissionEnable({
                ActionKey: self.FormName() + "Print",
                Enabled: false,
                Context: self.TabPage.Context()
            });
        }
        else {
            var selection = self.Selection.peek();
            BaoMenu.permissionEnable({
                ActionKey: self.FormName() + "Print",
                Enabled: true,
                Context: self.TabPage.Context()
            });
            if (selection && selection.length > 0) {
                BaoMenu.permissionEnable({
                    ActionKey: self.FormName() + "Edit",
                    Enabled: true,
                    Context: self.TabPage.Context()
                });
                BaoMenu.permissionEnable({
                    ActionKey: self.FormName() + "Delete",
                    Enabled: true,
                    Context: self.TabPage.Context()
                });
            }
            else {
                BaoMenu.permissionEnable({
                    ActionKey: self.FormName() + "Edit",
                    Enabled: false,
                    Context: self.TabPage.Context()
                });
                BaoMenu.permissionEnable({
                    ActionKey: self.FormName() + "Delete",
                    Enabled: false,
                    Context: self.TabPage.Context()
                });
            }
        }
    }
};
WhiteboardReportViewModel.prototype["new"] = function () {
    var linkHash = "whiteboard/" + Guid() + "/" + this.TabPage.ObjectId();
    baoRouter.setHash(linkHash);
};
WhiteboardReportViewModel.prototype.edit = function () {
    var selection = this.Selection();
    if (selection && selection.length > 0) {
        baoRouter.setHash("whiteboard/" + selection[0].InstructionId() + "/" + this.TabPage.ObjectId());
    }
};
WhiteboardReportViewModel.prototype["delete"] = function () {
    var self = this;
    var selection = self.Selection();
    if (selection && selection.length > 0) {
        var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.WhiteboardDeleteQuestion), "yesno");
        dialog.DialogResult.subscribe(function (canDelete) {
            if (canDelete) {
                self.TabPage.IsLoading(true);
                return Bao.post("Whiteboard/Delete", JSON.stringify({
                    reportId: self.TabPage.ObjectId(),
                    instructionIds: [selection[0].InstructionId()]
                })).then(function (deleted) {
                    self.Selection([]);
                    if (deleted > 0) {
                        self.showAlert(finitoService.MessageKeys.WhiteboardDeleteSuccessful);
                        self.refresh();
                    }
                    else {
                        self.showAlert(finitoService.MessageKeys.WhiteboardDeleteError, "danger");
                    }
                    self.TabPage.IsLoading(false);
                });
            }
        });
    }
};
WhiteboardReportViewModel.prototype.refresh = function () {
    var self = this;
    self.TabPage.IsLoading(true);
    return this.getWhiteboardEntries().then(function () {
        self.TabPage.IsLoading(false);
    });
};
WhiteboardReportViewModel.prototype.print = function () {
    window.open("WhiteboardReport/Print?" + $.param({
        id: this.ReportId(),
        showDeleted: this.ShowDeletedWhiteboardEntries()
    }));
};
export default WhiteboardReportViewModel;